import { Dispatch } from 'redux';
import { authUser } from '@services/authService';
import { setMgLocalStorage } from '@utils';
import { authActionTypes } from './actionTypes/auth';
import { failure, loading } from './commonActions';
import { setCurrentUser, setUserMetadata } from './userActions';
import { MgLocalStorageKeys } from '@enums';
import { setNotification } from '@actions/appActions';
import { Credentials } from '@types';
import { getCurrentUser, getUserMetadata } from '@services/userService';
import { setSubmissionUser } from '@actions/submissionEnvironmentActions';
import { getAppConfig } from "@services/publicService";
import { setConfigVariables } from "@actions/appEnvironmentActions";

export const setLoggedIn = (payload = true) => {
  return {
    type: authActionTypes.LOGIN,
    payload: payload,
  };
};

export const setToken = (token: string | null) => {
  setMgLocalStorage(MgLocalStorageKeys.TOKEN, token || '');
  return {
    type: authActionTypes.SET_TOKEN,
    payload: token,
  };
};

export const makeLogin = (credentials: Credentials) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await authUser(credentials);
      dispatch(setToken(response.data.token));
      const user = await getCurrentUser();
      const metadata = await getUserMetadata();
      const appConfig = await getAppConfig();
      dispatch(setUserMetadata(metadata));
      dispatch(setCurrentUser(user));
      dispatch(setConfigVariables(appConfig));
      dispatch(setSubmissionUser(user));
      dispatch(setLoggedIn(true));

      return response;
    } catch (err) {
      dispatch(setNotification({ textKey: 'incorrect_credentials', variant: 'error' }));
      dispatch(failure(true, 'login'));
    } finally {
      dispatch(loading(false, 'app'));
    }
  };
};

export const logout = () => {
  return (dispatch: Dispatch) => {
    dispatch(setToken(null));
    dispatch(setCurrentUser(null));
    dispatch(setLoggedIn(false));
  };
};
